import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error';
import { cartDuck } from '../cart'; // Utilities
// import environment from '../../environments/qa';
// // import environment from 'environment';

import * as UTIL from '../../util';
import gaTracker from '../../util/ga-analytics/gaTracker';
import { waitlistDuck } from "../waitlist";
import { wishlistDuck } from '../wishlist';
var waitlistOperations = waitlistDuck.operations;
var Creators = Actions.Creators;
var setLoaded = Creators.setLoaded;
var setLocated = Creators.setLocated;
var setUserModifiedAction = Creators.setUserModifiedAction;
var setSource = Creators.setSource;
var requestGeoIp = Creators.requestGeoIp;
var changePreferredLocation = Creators.changePreferredLocation;
var changeLatLon = Creators.changeLatLon;
var changeZipCode = Creators.changeZipCode;
var setLocationAction = Creators.setLocation;
var requestLocations = Creators.requestLocations;
var requestZipcodes = Creators.requestZipcodes;
var requestLocationLatLon = Creators.requestLocationLatLon;
var receiveLocations = Creators.receiveLocations;
var receiveAdditionalLocations = Creators.receiveAdditionalLocations;
var receiveLatLon = Creators.receiveLatLon;
var toggleChangeModal = Creators.toggleChangeModal;
var toggleChangeNoLocationModal = Creators.toggleChangeNoLocationModal;
var requestFromUrl = Creators.requestFromUrl;
var setMapActive = Creators.setMapActive;
var changeTripPlanner = Creators.changeTripPlanner;
var locationFinderErr = Creators.locationFinderErr;
var setTripPlannerLoc = Creators.setTripPlannerLoc;
var savePathInfo = Creators.savePathInfo;
var flipModified = Creators.flipModified;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;
var cartOperations = cartDuck.operations;
var clearCart = cartOperations.clearCart; // Account for SSR by checking for the Window object
// const storage = (typeof window !== 'undefined') ? JSON.parse(window.localStorage.getItem('persist:cb-ds-loc')) : {};

var locationSearchUrl = UTIL.apiUtil.API.location.getLocationSearch;
var locationGeoIpUrl = ""; //GeoIP has been sunset

var locationZipCodeUrl = UTIL.apiUtil.API.location.getZipcodeSearch;
var locationIdUrl = UTIL.apiUtil.API.location.getVendorid;
var fakeLocationUntilImplemented = {
  results: [{
    "MilesFromSource": 15.326971729213039,
    "AboutUsDescription": "",
    "Address1": "7408 Shockley Dr.",
    "Address2": "I-270 & SR 85",
    "AlternateName": "Frederick",
    "AvgWaitTime": "0 minutes",
    "BeerWine": "",
    "Careers": "",
    "Catering": true,
    "CateringDelivery": true,
    "CateringDeliveryAvailable": true,
    "CateringDeliveryLaunchDate": "0001-01-01T00:00:00",
    "CateringMenu": false,
    "City": "Frederick",
    "CompanyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7",
    "Country": "US",
    "Curbside": true,
    "DineIn": false,
    "DispatchIndividual": true,
    "EnglishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_262_BK_MENU_EN.pdf",
    "EnglishLunchDinner": "",
    "FacebookPage": "",
    "FamilyValueMeals": false,
    "FeaturedMenu": "",
    "FridayClose": "10:00 PM",
    "FridayOpen": "8:00 AM",
    "FrontPorchDining": false,
    "GhostKitchen": false,
    "HolidayHns": false,
    "IndividualMeals": true,
    "IntegratedCateringDelivery": false,
    "LocalPageImage1": "",
    "LocalPageImage2": "",
    "LocalPageImage3": "",
    "MaxLiveDate": "0001-01-01T00:00:00",
    "MondayClose": "9:00 PM",
    "MondayOpen": "8:00 AM",
    "Name": "Cracker Barrel",
    "NowOpen": "",
    "OloCateringUniqueName": "frederick-md-catering",
    "OloStore": true,
    "OloUniqueName": "frederick-md",
    "OnlineOrdering": false,
    "OpeningSoon": false,
    "Park": true,
    "PayInApp": false,
    "Phone": "301-682-4405",
    "PickUp": true,
    "POSSystem": "",
    "SaturdayClose": "10:00 PM",
    "SaturdayOpen": "8:00 AM",
    "SpanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_262_BK_MENU_ES.pdf",
    "SpanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_262_LD_MENU_ES.pdf",
    "SpecialHours": "",
    "SpecialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ",
    "State": "MD",
    "StoreId": "0e812986-722c-497b-90e7-0fc0503fc8a3",
    "StoreNumber": "262",
    "SundayClose": "9:00 PM",
    "SundayOpen": "8:00 AM",
    "TemporarilyClosed": false,
    "ThursdayClose": "9:00 PM",
    "ThursdayOpen": "8:00 AM",
    "TuesdayClose": "9:00 PM",
    "TuesdayOpen": "8:00 AM",
    "VendorId": "62520",
    "VendorIdCatering": "63285",
    "Waitlist": false,
    "WebAheadStatus": "Available",
    "WednesdayClose": "9:00 PM",
    "WednesdayOpen": "8:00 AM",
    "YelpReOpenDate": "0001-01-01T00:00:00",
    "Zip": "21704-8362",
    "Latitude": "39.3766667",
    "Longitude": "-77.4069903",
    "DetailLink": "http://crackerbarrel.dev.local/en/Locations/States/md/frederick/262"
  }, {
    "MilesFromSource": 18.08774879011672,
    "AboutUsDescription": "",
    "Address1": "23030 Indian Creek Dr.",
    "Address2": "",
    "AlternateName": "Sterling",
    "AvgWaitTime": "0 minutes",
    "BeerWine": "",
    "Careers": "",
    "Catering": true,
    "CateringDelivery": true,
    "CateringDeliveryAvailable": true,
    "CateringDeliveryLaunchDate": "0001-01-01T00:00:00",
    "CateringMenu": false,
    "City": "Sterling",
    "CompanyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7",
    "Country": "US",
    "Curbside": true,
    "DineIn": false,
    "DispatchIndividual": true,
    "EnglishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_704_BK_MENU_EN.pdf",
    "EnglishLunchDinner": "",
    "FacebookPage": "",
    "FamilyValueMeals": false,
    "FeaturedMenu": "",
    "FridayClose": "10:00 PM",
    "FridayOpen": "8:00 AM",
    "FrontPorchDining": false,
    "GhostKitchen": false,
    "HolidayHns": false,
    "IndividualMeals": true,
    "IntegratedCateringDelivery": false,
    "LocalPageImage1": "",
    "LocalPageImage2": "",
    "LocalPageImage3": "",
    "MaxLiveDate": "0001-01-01T00:00:00",
    "MondayClose": "9:00 PM",
    "MondayOpen": "8:00 AM",
    "Name": "Cracler Barrel",
    "NowOpen": "",
    "OloCateringUniqueName": "sterling-va-catering",
    "OloStore": true,
    "OloUniqueName": "sterling-va",
    "OnlineOrdering": false,
    "OpeningSoon": false,
    "Park": false,
    "PayInApp": false,
    "Phone": "703-464-0044",
    "PickUp": true,
    "POSSystem": "",
    "SaturdayClose": "10:00 PM",
    "SaturdayOpen": "8:00 AM",
    "SpanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_704_BK_MENU_ES.pdf",
    "SpanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_704_LD_MENU_ES.pdf",
    "SpecialHours": "",
    "SpecialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ",
    "State": "VA",
    "StoreId": "fff292e4-247f-46e3-8f0c-76057b998cbe",
    "StoreNumber": "704",
    "SundayClose": "9:00 PM",
    "SundayOpen": "8:00 AM",
    "TemporarilyClosed": false,
    "ThursdayClose": "9:00 PM",
    "ThursdayOpen": "8:00 AM",
    "TuesdayClose": "9:00 PM",
    "TuesdayOpen": "8:00 AM",
    "VendorId": "62993",
    "VendorIdCatering": "63671",
    "Waitlist": false,
    "WebAheadStatus": "Available",
    "WednesdayClose": "9:00 PM",
    "WednesdayOpen": "8:00 AM",
    "YelpReOpenDate": "0001-01-01T00:00:00",
    "Zip": "20166-",
    "Latitude": "38.9799544",
    "Longitude": "-77.4327704",
    "DetailLink": "http://crackerbarrel.dev.local/en/Locations/States/va/sterling/704"
  }, {
    "MilesFromSource": 30.1294502489708,
    "AboutUsDescription": "",
    "Address1": "1520 W. Nursery Rd",
    "Address2": "Balt-Wash Pkwy. & W. Nursery Rd.",
    "AlternateName": "Linthicum Heights",
    "AvgWaitTime": "About 5 minutes",
    "BeerWine": "",
    "Careers": "",
    "Catering": true,
    "CateringDelivery": true,
    "CateringDeliveryAvailable": true,
    "CateringDeliveryLaunchDate": "0001-01-01T00:00:00",
    "CateringMenu": false,
    "City": "Linthicum Heights",
    "CompanyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7",
    "Country": "US",
    "Curbside": true,
    "DineIn": false,
    "DispatchIndividual": true,
    "EnglishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_718_BK_MENU_EN.pdf",
    "EnglishLunchDinner": "",
    "FacebookPage": "",
    "FamilyValueMeals": false,
    "FeaturedMenu": "",
    "FridayClose": "10:00 PM",
    "FridayOpen": "8:00 AM",
    "FrontPorchDining": false,
    "GhostKitchen": false,
    "HolidayHns": false,
    "IndividualMeals": true,
    "IntegratedCateringDelivery": false,
    "LocalPageImage1": "",
    "LocalPageImage2": "",
    "LocalPageImage3": "",
    "MaxLiveDate": "0001-01-01T00:00:00",
    "MondayClose": "9:00 PM",
    "MondayOpen": "8:00 AM",
    "Name": "Cracker Barrel",
    "NowOpen": "",
    "OloCateringUniqueName": "linthicummd-catering",
    "OloStore": true,
    "OloUniqueName": "linthicummd",
    "OnlineOrdering": false,
    "OpeningSoon": false,
    "Park": false,
    "PayInApp": false,
    "Phone": "410-859-8724",
    "PickUp": true,
    "POSSystem": "",
    "SaturdayClose": "10:00 PM",
    "SaturdayOpen": "8:00 AM",
    "SpanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_718_BK_MENU_ES.pdf",
    "SpanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_718_LD_MENU_ES.pdf",
    "SpecialHours": "",
    "SpecialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ",
    "State": "MD",
    "StoreId": "91f7b8ca-79e7-4745-a5f4-595ebf585fb0",
    "StoreNumber": "718",
    "SundayClose": "9:00 PM",
    "SundayOpen": "8:00 AM",
    "TemporarilyClosed": false,
    "ThursdayClose": "9:00 PM",
    "ThursdayOpen": "8:00 AM",
    "TuesdayClose": "9:00 PM",
    "TuesdayOpen": "8:00 AM",
    "VendorId": "63002",
    "VendorIdCatering": "63680",
    "Waitlist": false,
    "WebAheadStatus": "Available",
    "WednesdayClose": "9:00 PM",
    "WednesdayOpen": "8:00 AM",
    "YelpReOpenDate": "0001-01-01T00:00:00",
    "Zip": "21090",
    "Latitude": "39.2091724",
    "Longitude": "-76.679982",
    "DetailLink": "http://crackerbarrel.dev.local/en/Locations/States/md/linthicum-heights/718"
  }, {
    "MilesFromSource": 30.883005734644957,
    "AboutUsDescription": "",
    "Address1": "10801 Battleview Pkwy.",
    "Address2": "I-66 & SR 234",
    "AlternateName": "Manassas",
    "AvgWaitTime": "0 minutes",
    "BeerWine": "",
    "Careers": "",
    "Catering": true,
    "CateringDelivery": true,
    "CateringDeliveryAvailable": true,
    "CateringDeliveryLaunchDate": "0001-01-01T00:00:00",
    "CateringMenu": false,
    "City": "Manassas",
    "CompanyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7",
    "Country": "US",
    "Curbside": true,
    "DineIn": false,
    "DispatchIndividual": true,
    "EnglishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_238_BK_MENU_EN.pdf",
    "EnglishLunchDinner": "",
    "FacebookPage": "",
    "FamilyValueMeals": false,
    "FeaturedMenu": "",
    "FridayClose": "10:00 PM",
    "FridayOpen": "8:00 AM",
    "FrontPorchDining": false,
    "GhostKitchen": false,
    "HolidayHns": false,
    "IndividualMeals": true,
    "IntegratedCateringDelivery": false,
    "LocalPageImage1": "",
    "LocalPageImage2": "",
    "LocalPageImage3": "",
    "MaxLiveDate": "0001-01-01T00:00:00",
    "MondayClose": "9:00 PM",
    "MondayOpen": "8:00 AM",
    "Name": "Cracker Barrel",
    "NowOpen": "",
    "OloCateringUniqueName": "manassas-va-catering",
    "OloStore": true,
    "OloUniqueName": "manassas-va",
    "OnlineOrdering": false,
    "OpeningSoon": false,
    "Park": true,
    "PayInApp": false,
    "Phone": "703-369-4641",
    "PickUp": true,
    "POSSystem": "",
    "SaturdayClose": "10:00 PM",
    "SaturdayOpen": "8:00 AM",
    "SpanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_238_BK_MENU_ES.pdf",
    "SpanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_238_LD_MENU_ES.pdf",
    "SpecialHours": "",
    "SpecialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ",
    "State": "VA",
    "StoreId": "d04fb376-75a2-47d5-afb7-6e1bd3e614e0",
    "StoreNumber": "238",
    "SundayClose": "9:00 PM",
    "SundayOpen": "8:00 AM",
    "TemporarilyClosed": false,
    "ThursdayClose": "9:00 PM",
    "ThursdayOpen": "8:00 AM",
    "TuesdayClose": "9:00 PM",
    "TuesdayOpen": "8:00 AM",
    "VendorId": "62500",
    "VendorIdCatering": "63265",
    "Waitlist": false,
    "WebAheadStatus": "Available",
    "WednesdayClose": "9:00 PM",
    "WednesdayOpen": "8:00 AM",
    "YelpReOpenDate": "0001-01-01T00:00:00",
    "Zip": "20109-2349",
    "Latitude": "38.8046019",
    "Longitude": "-77.5197521",
    "DetailLink": "http://crackerbarrel.dev.local/en/Locations/States/va/manassas/238"
  }, {
    "MilesFromSource": 38.313586142210077,
    "AboutUsDescription": "",
    "Address1": "18214 Col. Henry K. Douglas Dr.",
    "Address2": "I-70 & SR 65",
    "AlternateName": "Hagerstown",
    "AvgWaitTime": "0 minutes",
    "BeerWine": "",
    "Careers": "",
    "Catering": true,
    "CateringDelivery": true,
    "CateringDeliveryAvailable": true,
    "CateringDeliveryLaunchDate": "0001-01-01T00:00:00",
    "CateringMenu": false,
    "City": "Hagerstown",
    "CompanyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7",
    "Country": "US",
    "Curbside": true,
    "DineIn": false,
    "DispatchIndividual": true,
    "EnglishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_434_BK_MENU_EN.pdf",
    "EnglishLunchDinner": "",
    "FacebookPage": "",
    "FamilyValueMeals": false,
    "FeaturedMenu": "",
    "FridayClose": "10:00 PM",
    "FridayOpen": "8:00 AM",
    "FrontPorchDining": false,
    "GhostKitchen": false,
    "HolidayHns": false,
    "IndividualMeals": true,
    "IntegratedCateringDelivery": false,
    "LocalPageImage1": "",
    "LocalPageImage2": "",
    "LocalPageImage3": "",
    "MaxLiveDate": "0001-01-01T00:00:00",
    "MondayClose": "9:00 PM",
    "MondayOpen": "8:00 AM",
    "Name": "Cracker Barrel",
    "NowOpen": "",
    "OloCateringUniqueName": "hagerstown-md-catering",
    "OloStore": true,
    "OloUniqueName": "hagerstown-md",
    "OnlineOrdering": false,
    "OpeningSoon": false,
    "Park": true,
    "PayInApp": false,
    "Phone": "240-420-0955",
    "PickUp": true,
    "POSSystem": "",
    "SaturdayClose": "10:00 PM",
    "SaturdayOpen": "8:00 AM",
    "SpanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_434_BK_MENU_ES.pdf",
    "SpanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_434_LD_MENU_ES.pdf",
    "SpecialHours": "",
    "SpecialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ",
    "State": "MD",
    "StoreId": "0dc0541c-97c8-4cfa-852c-66f93c431d0d",
    "StoreNumber": "434",
    "SundayClose": "9:00 PM",
    "SundayOpen": "8:00 AM",
    "TemporarilyClosed": false,
    "ThursdayClose": "9:00 PM",
    "ThursdayOpen": "8:00 AM",
    "TuesdayClose": "9:00 PM",
    "TuesdayOpen": "8:00 AM",
    "VendorId": "62675",
    "VendorIdCatering": "63440",
    "Waitlist": false,
    "WebAheadStatus": "Available",
    "WednesdayClose": "9:00 PM",
    "WednesdayOpen": "8:00 AM",
    "YelpReOpenDate": "0001-01-01T00:00:00",
    "Zip": "21740-1562",
    "Latitude": "39.6008566",
    "Longitude": "-77.7307671",
    "DetailLink": "http://crackerbarrel.dev.local/en/Locations/States/md/hagerstown/434"
  }]
};
var fakeLocationUntilImplemented2 = {
  results: [{
    "MilesFromSource": 30.883005734644957,
    "AboutUsDescription": "",
    "Address1": "10801 Battleview Pkwy.",
    "Address2": "I-66 & SR 234",
    "AlternateName": "Manassas",
    "AvgWaitTime": "0 minutes",
    "BeerWine": "",
    "Careers": "",
    "Catering": true,
    "CateringDelivery": true,
    "CateringDeliveryAvailable": true,
    "CateringDeliveryLaunchDate": "0001-01-01T00:00:00",
    "CateringMenu": false,
    "City": "Manassas",
    "CompanyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7",
    "Country": "US",
    "Curbside": true,
    "DineIn": false,
    "DispatchIndividual": true,
    "EnglishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_238_BK_MENU_EN.pdf",
    "EnglishLunchDinner": "",
    "FacebookPage": "",
    "FamilyValueMeals": false,
    "FeaturedMenu": "",
    "FridayClose": "10:00 PM",
    "FridayOpen": "8:00 AM",
    "FrontPorchDining": false,
    "GhostKitchen": false,
    "HolidayHns": false,
    "IndividualMeals": true,
    "IntegratedCateringDelivery": false,
    "LocalPageImage1": "",
    "LocalPageImage2": "",
    "LocalPageImage3": "",
    "MaxLiveDate": "0001-01-01T00:00:00",
    "MondayClose": "9:00 PM",
    "MondayOpen": "8:00 AM",
    "Name": "Cracker Barrel",
    "NowOpen": "",
    "OloCateringUniqueName": "manassas-va-catering",
    "OloStore": true,
    "OloUniqueName": "manassas-va",
    "OnlineOrdering": false,
    "OpeningSoon": false,
    "Park": true,
    "PayInApp": false,
    "Phone": "703-369-4641",
    "PickUp": true,
    "POSSystem": "",
    "SaturdayClose": "10:00 PM",
    "SaturdayOpen": "8:00 AM",
    "SpanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_238_BK_MENU_ES.pdf",
    "SpanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_238_LD_MENU_ES.pdf",
    "SpecialHours": "",
    "SpecialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ",
    "State": "VA",
    "StoreId": "d04fb376-75a2-47d5-afb7-6e1bd3e614e0",
    "StoreNumber": "238",
    "SundayClose": "9:00 PM",
    "SundayOpen": "8:00 AM",
    "TemporarilyClosed": false,
    "ThursdayClose": "9:00 PM",
    "ThursdayOpen": "8:00 AM",
    "TuesdayClose": "9:00 PM",
    "TuesdayOpen": "8:00 AM",
    "VendorId": "62500",
    "VendorIdCatering": "63265",
    "Waitlist": false,
    "WebAheadStatus": "Available",
    "WednesdayClose": "9:00 PM",
    "WednesdayOpen": "8:00 AM",
    "YelpReOpenDate": "0001-01-01T00:00:00",
    "Zip": "20109-2349",
    "Latitude": "38.8046019",
    "Longitude": "-77.5197521",
    "DetailLink": "http://crackerbarrel.dev.local/en/Locations/States/va/manassas/238"
  }, {
    "MilesFromSource": 38.313586142210077,
    "AboutUsDescription": "",
    "Address1": "18214 Col. Henry K. Douglas Dr.",
    "Address2": "I-70 & SR 65",
    "AlternateName": "Hagerstown",
    "AvgWaitTime": "0 minutes",
    "BeerWine": "",
    "Careers": "",
    "Catering": true,
    "CateringDelivery": true,
    "CateringDeliveryAvailable": true,
    "CateringDeliveryLaunchDate": "0001-01-01T00:00:00",
    "CateringMenu": false,
    "City": "Hagerstown",
    "CompanyUid": "8ca6a7d3-8083-11e4-9f8d-22000b510bd7",
    "Country": "US",
    "Curbside": true,
    "DineIn": false,
    "DispatchIndividual": true,
    "EnglishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_434_BK_MENU_EN.pdf",
    "EnglishLunchDinner": "",
    "FacebookPage": "",
    "FamilyValueMeals": false,
    "FeaturedMenu": "",
    "FridayClose": "10:00 PM",
    "FridayOpen": "8:00 AM",
    "FrontPorchDining": false,
    "GhostKitchen": false,
    "HolidayHns": false,
    "IndividualMeals": true,
    "IntegratedCateringDelivery": false,
    "LocalPageImage1": "",
    "LocalPageImage2": "",
    "LocalPageImage3": "",
    "MaxLiveDate": "0001-01-01T00:00:00",
    "MondayClose": "9:00 PM",
    "MondayOpen": "8:00 AM",
    "Name": "Cracker Barrel",
    "NowOpen": "",
    "OloCateringUniqueName": "hagerstown-md-catering",
    "OloStore": true,
    "OloUniqueName": "hagerstown-md",
    "OnlineOrdering": false,
    "OpeningSoon": false,
    "Park": true,
    "PayInApp": false,
    "Phone": "240-420-0955",
    "PickUp": true,
    "POSSystem": "",
    "SaturdayClose": "10:00 PM",
    "SaturdayOpen": "8:00 AM",
    "SpanishBreakfast": "http://www.crackerbarrel.com/menupdfs/STORE_434_BK_MENU_ES.pdf",
    "SpanishLunchDinner": "http://www.crackerbarrel.com/menupdfs/STORE_434_LD_MENU_ES.pdf",
    "SpecialHours": "",
    "SpecialNotes": "Our kitchen is open for Curbside, Pickup & Delivery, but our dining room is closed temporarily due to COVID-19. Our retail store is open. ",
    "State": "MD",
    "StoreId": "0dc0541c-97c8-4cfa-852c-66f93c431d0d",
    "StoreNumber": "434",
    "SundayClose": "9:00 PM",
    "SundayOpen": "8:00 AM",
    "TemporarilyClosed": false,
    "ThursdayClose": "9:00 PM",
    "ThursdayOpen": "8:00 AM",
    "TuesdayClose": "9:00 PM",
    "TuesdayOpen": "8:00 AM",
    "VendorId": "62675",
    "VendorIdCatering": "63440",
    "Waitlist": false,
    "WebAheadStatus": "Available",
    "WednesdayClose": "9:00 PM",
    "WednesdayOpen": "8:00 AM",
    "YelpReOpenDate": "0001-01-01T00:00:00",
    "Zip": "21740-1562",
    "Latitude": "39.6008566",
    "Longitude": "-77.7307671",
    "DetailLink": "http://crackerbarrel.dev.local/en/Locations/States/md/hagerstown/434"
  }]
};

function fetchLocationResults(state, limit, radius) {
  var allowCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return function (dispatch) {
    var _state$location, _state$location$latLo, _state$location2, _state$location2$latL;

    if (state.location.source === 'gps' && allowCache) {
      //check for local storage
      return dispatch(receiveLocations({
        data: {
          results: state.location.results,
          userLatitude: state.location.userLatitude,
          userLongitude: state.location.userLongitude
        }
      }));
    }

    dispatch(requestLocations());

    if (((_state$location = state.location) === null || _state$location === void 0 ? void 0 : (_state$location$latLo = _state$location.latLon) === null || _state$location$latLo === void 0 ? void 0 : _state$location$latLo.latitude) && ((_state$location2 = state.location) === null || _state$location2 === void 0 ? void 0 : (_state$location2$latL = _state$location2.latLon) === null || _state$location2$latL === void 0 ? void 0 : _state$location2$latL.longitude) || UTIL.mobileAppUtil.isMobileApp()) {
      var _state$location3, _state$location3$latL, _state$location4, _state$location4$latL;

      var payload = {
        'limit': limit || 25,
        'radius': radius || 100,
        'latitude': "".concat(state === null || state === void 0 ? void 0 : (_state$location3 = state.location) === null || _state$location3 === void 0 ? void 0 : (_state$location3$latL = _state$location3.latLon) === null || _state$location3$latL === void 0 ? void 0 : _state$location3$latL.latitude),
        'longitude': "".concat(state === null || state === void 0 ? void 0 : (_state$location4 = state.location) === null || _state$location4 === void 0 ? void 0 : (_state$location4$latL = _state$location4.latLon) === null || _state$location4$latL === void 0 ? void 0 : _state$location4$latL.longitude)
      };
      var geoLocated = false;
      var geoIp = false;

      if (UTIL.mobileAppUtil.isMobileApp()) {
        var mobileGeolocation = UTIL.mobileAppUtil.getMobileLocation(); // grab location from local storage because we're using Capacitors under a non https protocol and Apple doesn't access to geolocation api on non-https sites

        if (mobileGeolocation === null || mobileGeolocation === void 0 ? void 0 : mobileGeolocation.latitude) payload.latitude = mobileGeolocation.latitude;
        if (mobileGeolocation === null || mobileGeolocation === void 0 ? void 0 : mobileGeolocation.longitude) payload.longitude = mobileGeolocation.longitude;
      }

      dispatch(receiveLatLon({
        position: {
          latitude: payload.latitude,
          longitude: payload.longitude
        }
      }), 'gps');
      return axios({
        method: 'get',
        headers: UTIL.apiUtil.setHeaders(),
        params: payload,
        url: locationSearchUrl
      }).then(function (json) {
        dispatch(setSource('gps'));
        var locationInfo = {
          data: {
            results: UTIL.locationMap(json.data),
            userLatitude: payload.latitude,
            userLongitude: payload.longitude
          }
        };
        var locationIds = UTIL.locationIdsUrl();
        dispatch(setLocation(locationInfo.data.results[0], Object.keys(locationIds).length ? locationIds.retaincart : "false"));
        return dispatch(receiveLocations(locationInfo, geoLocated, geoIp));
      }).catch(function (err) {
        //if error this line is called in promise
        dispatch(setLoaded());
        dispatch(receiveError(UTIL.buildError(err)));
      });
    } else {
      // dispatch(setSource('gps'));
      dispatch(setLoaded()); //commented due to error
      //dispatch(receiveError(UTIL.buildError(err)))
    }
  };
}

function fetchGeoIpResults(state, limit, radius) {
  /*
  returns a lat/log based on users ip address
  */
  return function (dispatch) {
    var _state$location5, _state$location5$loca;

    /*
    Return locations from local storage if already present.
    Avoids an additional call to the API.
    */
    if (state === null || state === void 0 ? void 0 : (_state$location5 = state.location) === null || _state$location5 === void 0 ? void 0 : (_state$location5$loca = _state$location5.location) === null || _state$location5$loca === void 0 ? void 0 : _state$location5$loca.address1) {
      return dispatch(receiveLocations({
        data: {
          results: state.location.results
        }
      }));
    }

    dispatch(requestLocations());
    var payload = {
      'limit': limit || 25,
      'radius': radius || 100
    };
    return axios({
      method: 'get',
      headers: UTIL.apiUtil.setHeaders(),
      params: payload // url: locationGeoIpUrl

    }).then(function (json) {
      dispatch(setSource('ip'));
      var locationInfo = {
        data: {
          results: UTIL.locationMap(json.data)
        }
      };
      dispatch(receiveLatLon(locationInfo));
    }).catch(function (err) {
      dispatch(setLoaded());
      dispatch(receiveError(UTIL.buildError(err, getLocationByZipcode)));
    });
  };
}

function fetchZipResults(state, limit, radius, filters) {
  var isLocationSearchPage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return function (dispatch) {
    dispatch(requestZipcodes());
    var gaData = {
      gtm: {
        uniqueEventId: '43',
        //May not be setup
        elementId: "fetch-zip"
      },
      event: 'gtm.click'
    };
    gaTracker(gaData);
    var payload = {
      'limit': limit || 25,
      'radius': radius || 100,
      'zipcode': "".concat(state.location.zipcode),
      'filters': filters.join(",") || undefined,
      'isLocationSearchPage': isLocationSearchPage
    };

    if (!state.location.zipcode) {
      return;
    }

    return axios({
      method: 'get',
      headers: UTIL.apiUtil.setHeaders(),
      params: payload,
      url: locationZipCodeUrl
    }).then(function (json) {
      if (json.status === 204 || json.status === '204') {
        // No results returned
        var error = {
          response: {
            data: {
              results: {
                code: "cb5501"
              }
            }
          }
        };
        dispatch(locationFinderErr(UTIL.buildError(error)));
        dispatch(receiveError(UTIL.buildError(error)));
      } else {
        var locationInfo = {
          data: {
            results: UTIL.locationMap(json.data)
          }
        };
        dispatch(receiveAdditionalLocations(locationInfo));
        dispatch(flipModified());
      }
    }).catch(function (err) {
      dispatch(setLoaded());
      var gaDataError = {
        gtm: {
          uniqueEventId: '45',
          elementId: "fetch-zip-generic",
          error: err
        },
        event: 'gtm.error'
      };
      gaTracker(gaDataError);
      console.log(err.Message, "ERR");
      dispatch(locationFinderErr());
      dispatch(receiveError(UTIL.buildError(err, getLocationByZipcode)));
    });
  };
}

function fetchFromUrl(state, locationIds) {
  return function (dispatch) {
    dispatch(requestZipcodes());
    dispatch(flipModified());
    var payload = {
      'limit': 25,
      'radius': 100,
      'zipcode': "".concat(state.location.addressparam)
    };
    return axios({
      method: 'get',
      headers: UTIL.apiUtil.setHeaders(),
      params: payload,
      url: locationZipCodeUrl
    }).then(function (json) {
      var locationInfo = {
        data: {
          results: UTIL.locationMap(json.data)
        }
      };
      var location = locationInfo.data.results;

      if (location.length) {
        var store = location[0];
        dispatch(setLocation(store));
      }
    }).catch(function (err) {
      dispatch(setLoaded());
      dispatch(receiveError(UTIL.buildError(err, getLocationByZipcode)));
    });
  };
}

function fetchMapById(state, address) {
  return function (dispatch) {
    var payload = {
      'vendorid': address.vendorid,
      'vendorcateringid': address.vendorcateringid
    };
    return axios({
      method: 'get',
      headers: UTIL.apiUtil.setHeaders(),
      params: payload,
      url: locationIdUrl
    }).then(function (json) {
      var locationInfo = {
        data: {
          results: UTIL.locationMap([json.data])
        }
      };
      var location = locationInfo.data.results;

      if (location.length) {
        var store = location[0];
        dispatch(setLocation(store, address.retaincart));
      }
    }).catch(function (err) {
      dispatch(setLoaded());
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function fetchMapLocationLatLon(state, lat, lon, limit, radius) {
  return function (dispatch) {
    dispatch(requestLocationLatLon());
    var payload = {
      'limit': limit || 25,
      'radius': radius || 100,
      'latitude': "".concat(lat),
      'longitude': "".concat(lon)
    };
    return axios({
      method: 'get',
      headers: UTIL.apiUtil.setHeaders(),
      params: payload,
      url: locationSearchUrl
    }).then(function (json) {
      var locationInfo = {
        data: {
          results: UTIL.locationMap(json.data),
          userLatitude: lat,
          userLongitude: long
        }
      };
      dispatch(receiveLocations(locationInfo));
    }).catch(function (err) {
      dispatch(setLoaded());
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

var getLocationByIp = function getLocationByIp(limit, radius) {
  return function (dispatch, getState) {
    return dispatch(fetchGeoIpResults(getState(), limit, radius));
  };
};

var getLocationByGps = function getLocationByGps() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 25;
  var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var allowCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState) {
    return dispatch(fetchLocationResults(getState(), limit, radius, allowCache));
  };
};

var mobileAutoSelectLocation = function mobileAutoSelectLocation() {
  return function (dispatch, getState) {
    return dispatch(fetchLocationResults(getState(), 1, 100, false));
  };
};

var getLocationByLatLon = function getLocationByLatLon(latitude, longitude) {
  return function (dispatch) {
    return dispatch(fetchLocationResults({
      location: {
        latLon: {
          latitude: latitude,
          longitude: longitude
        }
      }
    }, 1, 100, false));
  };
};

var setUserModified = function setUserModified(userModified) {
  return function (dispatch, getState) {
    return dispatch(setUserModifiedAction(userModified));
  };
};

var getLocationByZipcode = function getLocationByZipcode(limit, radius) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var isLocationSearchPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch, getState) {
    return dispatch(fetchZipResults(getState(), limit, radius, filter, isLocationSearchPage));
  };
};

var getLocationFromUrl = function getLocationFromUrl(locationIds) {
  return function (dispatch, getState) {
    return dispatch(fetchFromUrl(getState()), locationIds);
  };
};

var getLocations = function getLocations(limit, radius) {
  return function (dispatch, getState) {
    return dispatch(fetchMapResults(getState(), limit, radius));
  };
};

var setLocation = function setLocation(location) {
  var retaincart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'false';
  // Initalize as false string as we get a string back from the abandoned cart  
  return function (dispatch, getState) {
    var _state$cbLocation;

    var state = getState();
    var current = state === null || state === void 0 ? void 0 : (_state$cbLocation = state.cbLocation) === null || _state$cbLocation === void 0 ? void 0 : _state$cbLocation.location;
    var sameStore = (current === null || current === void 0 ? void 0 : current.vendorid) === (location === null || location === void 0 ? void 0 : location.vendorid) && (current === null || current === void 0 ? void 0 : current.vendoridcatering) === (location === null || location === void 0 ? void 0 : location.vendoridcatering);

    if (!sameStore && retaincart === 'false') {
      dispatch(clearCart(getState()));
    }

    var storeId = (location === null || location === void 0 ? void 0 : location.StoreId) || (location === null || location === void 0 ? void 0 : location.storeId) || (location === null || location === void 0 ? void 0 : location.storeuid);
    dispatch(waitlistOperations.checkWaitlistAvailableQSR(storeId === undefined ? "" : storeId)).then(function (res) {
      var WebAheadStatus = res.WebAheadStatus,
          Quote = res.Quote;

      var _ref = Quote || {},
          ConsumerQuoteString = _ref.ConsumerQuoteString;

      var newLocation = _objectSpread(_objectSpread({}, location), {}, {
        WebAheadStatus: WebAheadStatus,
        AvgWaitTime: ConsumerQuoteString,
        avgwaittime: ConsumerQuoteString,
        webaheadstatus: WebAheadStatus
      });

      dispatch(setLocationAction(newLocation));
      dispatch(wishlistDuck.operations.handleGetWishlist(location === null || location === void 0 ? void 0 : location.olo_unique_name));
    }).catch(function () {});
  };
};

var getLocationWaitTime = function getLocationWaitTime(location) {
  return function (dispatch, getState) {
    dispatch(waitlistOperations.checkWaitlistAvailableQSR(location === null || location === void 0 ? void 0 : location.storeuid)).then(function (res) {
      var WebAheadStatus = res.WebAheadStatus,
          Quote = res.Quote;

      var _ref2 = Quote || {},
          ConsumerQuoteString = _ref2.ConsumerQuoteString;

      var newLocation = _objectSpread(_objectSpread({}, location), {}, {
        WebAheadStatus: WebAheadStatus,
        AvgWaitTime: ConsumerQuoteString,
        avgwaittime: ConsumerQuoteString,
        webaheadstatus: WebAheadStatus
      });

      return dispatch(setLocationAction(newLocation));
    }).catch(function () {
      console.log("WAIT TIME ERROR");
    });
  };
};

var requestById = function requestById(address) {
  return function (dispatch, getState) {
    return dispatch(fetchMapById(getState(), address));
  };
};

var changeMapLocation = function changeMapLocation(lat, lon, limit) {
  return function (dispatch, getState) {
    return dispatch(fetchMapLocationLatLon(getState(), lat, lon, limit));
  };
};

export var fetchLocationByStore = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(storeNumber) {
    var storeInfo, apiResponse, responseObj;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            storeInfo = {};
            _context.prev = 1;
            _context.next = 4;
            return fetch(UTIL.apiUtil.API.location.getLocationByStoreNumber + "?storenumber=".concat(storeNumber), {
              method: 'GET'
            });

          case 4:
            apiResponse = _context.sent;
            _context.next = 7;
            return apiResponse.json();

          case 7:
            responseObj = _context.sent;
            storeInfo = responseObj;
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);

          case 14:
            return _context.abrupt("return", storeInfo);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));

  return function fetchLocationByStore(_x) {
    return _ref3.apply(this, arguments);
  };
}();
export default {
  changePreferredLocation: changePreferredLocation,
  getLocations: getLocations,
  changeLatLon: changeLatLon,
  changeZipCode: changeZipCode,
  setLocation: setLocation,
  requestGeoIp: requestGeoIp,
  getLocationByIp: getLocationByIp,
  getLocationByGps: getLocationByGps,
  mobileAutoSelectLocation: mobileAutoSelectLocation,
  setUserModified: setUserModified,
  getLocationByZipcode: getLocationByZipcode,
  getLocationByLatLon: getLocationByLatLon,
  requestFromUrl: requestFromUrl,
  getLocationFromUrl: getLocationFromUrl,
  toggleChangeModal: toggleChangeModal,
  toggleChangeNoLocationModal: toggleChangeNoLocationModal,
  requestById: requestById,
  changeMapLocation: changeMapLocation,
  setMapActive: setMapActive,
  changeTripPlanner: changeTripPlanner,
  setTripPlannerLoc: setTripPlannerLoc,
  savePathInfo: savePathInfo,
  setLoaded: setLoaded,
  setLocated: setLocated
};